import { useState, FC, MouseEvent } from 'react'
import { noop } from 'lodash'
import Button from '@components/Button'
import ResourcePermissionsModal from '@features/resource_permissions/components/ResourcePermissionsModal'
import { ReadPermissionsActionProps } from '../../types'

const ReadPermissionsAction: FC<ReadPermissionsActionProps> = ({ resourceId, resourceType, onDone = noop }) => {
  const [modalVisible, setModalVisible] = useState(false)

  const toggleModalVisibility = () => {
    const nextVal = !modalVisible
    setModalVisible(nextVal)
    if (nextVal === false) {
      onDone()
    }
  }

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    toggleModalVisibility()
  }

  const content = modalVisible ? (
    <ResourcePermissionsModal
      resourceId={resourceId}
      resourceType={resourceType}
      show={modalVisible}
      onClose={toggleModalVisibility}
    />
  ) : null

  return (
    <>
      <Button onClick={handleClick} className="button-reset popover-menu-button">
        Permissions & Access
      </Button>
      {content}
    </>
  )
}

export default ReadPermissionsAction
